import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    wrapper: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        padding: '30px 20px',
        gap: '30px',
        [theme.breakpoints.up('md')]: {
            width: '494px',
            gap: '40px',
        },
        marginBottom: '83px',
    }),
};
